import { useQuery } from 'react-query';
import { BannerDTO, BannerSubpage } from 'src/common/models/banner';
import { BaseAxios } from 'src/common/services/axios';
import { QueryKey } from 'src/config/queryKey';
import { CourseViewType } from 'src/state/courseListing/courseListingReducer';
import styled, { css } from 'styled-components';
import { flatten } from 'src/lib/axios';
import { useSelector } from 'react-redux';
import { courseListingSelectedCategoriesSelector } from 'src/state/courseListing/courseListingSelectors';
import { media } from 'src/config/breakpoints';

const Text = styled.div`
  color: #343f4e;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 10px;
`;

const Container = styled.div`
  border-radius: 6px;
  background: rgba(245, 246, 247, 0.5);
  overflow: hidden;
  position: relative;
  width: 100%;
  display: grid;
  place-content: center;

  min-height: 180px;

  ${media.w.min.px576(css`
    min-height: 365px;
  `)}
`;

const Image = styled.img`
  max-width: 100%;
  height: auto;
`;

export function Banner({ viewType }: { viewType: CourseViewType }) {
  const selectedCategories = useSelector(courseListingSelectedCategoriesSelector);
  const selectedCategoryIDs = Object.keys(selectedCategories).filter(
    (key) => selectedCategories[key],
  );

  const activeCategory = selectedCategoryIDs.at(0) ?? null;

  const { data } = useQuery<BannerDTO | null>(
    [QueryKey.Banner, viewType, activeCategory],
    async () => {
      if (activeCategory) {
        return await BaseAxios.get<BannerDTO>('/api/banners/banner', {
          params: {
            subpage: BannerSubpage.CATEGORY,
            categoryId: activeCategory,
          },
        }).then(flatten);
      }

      const subpage = {
        [CourseViewType.All]: null,
        [CourseViewType.CourseBundle]: BannerSubpage.COURSE_BUNDLE,
        [CourseViewType.Elearning]: BannerSubpage.E_LEARNING,
        [CourseViewType.Online]: BannerSubpage.ONLINE,
      }[viewType];

      if (!subpage) {
        return null;
      }

      return await BaseAxios.get<BannerDTO>('/api/banners/banner', {
        params: { subpage },
      }).then(flatten);
    },
  );

  if (!data) {
    return <></>;
  }

  const url = data.link;

  return (
    <div>
      <Text>Oferta promocyjna</Text>

      {url ? (
        <Container as="a" href={url} target="_blank">
          <Image src={data?.bannerLogo.url} />
        </Container>
      ) : (
        <Container>
          <Image src={data?.bannerLogo.url} />
        </Container>
      )}
    </div>
  );
}
